export default function GameOver({ winner, isDrawn, onRestart }) {
  return (
    <div id="game-over">
      <h2>Game Over!!</h2>
      {winner && <p>{winner} won!!</p>}
      {isDrawn && <p>its a tie</p>}
      <p>
        <button onClick={onRestart}>Rematch!</button>
      </p>
    </div>
  );
}
